'use client'

import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/utilities/cn'

export interface DetailsProps {
  header: string
  content: string
  className?: string
}

export const Details: React.FC<DetailsProps> = ({ 
  header, 
  content, 
  className 
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen((prev) => !prev)

  return (
    <div className={cn('p-2 bg-primary text-white rounded-xl mb-2', className)}>
      <div
        className={'flex align-baseline select-none'}
        onClick={toggleOpen}
        style={{ cursor: 'pointer' }}
      >
        <div className={'inline-block size-6 mr-1'}>
          <ChevronDown className={'w-6 h-6'} />
        </div>
        <strong>{header}</strong>
      </div>
      <div
        style={{
          maxHeight: isOpen ? '200px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
        }}
      >
        <div style={{ transition: 'padding 0.3s ease' }} className={'p-2'}>
          {content}
        </div>
      </div>
    </div>
  )
}